import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const DependencyBroadcastEventSchema = order.fulfillmentService.versions.v1.schemas.DEPENDENCY_BROADCAST_SCHEMA;

export type DependencyBroadcastEvent = z.infer<typeof DependencyBroadcastEventSchema>;

export const DependencyBroadcastEventV2Schema =
    order.fulfillmentService.versions.v2.schemas.DEPENDENCY_BROADCAST_SCHEMA;

export type DependencyBroadcastEventV2 = z.infer<typeof DependencyBroadcastEventV2Schema>;
